import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import skillData from "../../data/skill.json";
import "./skills.css";

export default function Skills() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="skill">
      <div className="container">
        <div className="skillTitle">
          <h2 className="titleHead">My Skills</h2>
          <p className="titleDoc">What I Know</p>
        </div>

        {Object.entries(skillData.skills).map(([category, skills]) => (
          <div key={category} className="skillCategory" data-aos="fade-up">
            <h3 className="categoryTitle">{category}</h3>
            <div className="skillItems">
              {skills.map(({ id, title, icon }) => (
                <article key={id} className="skillList">
                  <p className="skillText">{title}</p>
                  <div className="skillImg">
                    <img src={icon} alt={`${title} logo`} />
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
